<script lang="ts" setup>
import type { UseScrollReturn } from '@vueuse/core'
import { vScroll } from '@vueuse/components'

const props = defineProps<{
  name: string
  isDesktop?: boolean
}>()

const { open: galleryFullscreen } = useUiDialog('media-gallery')

const {
  galleryItems,
  activeItem,
  gallery,
  // toggleFullscreen,
  getImageFromProvider,
  // isFullscreen
} = useUiMediaGallery(props.name)

let timer: ReturnType<typeof setTimeout> | null = null
function onScroll(state: UseScrollReturn) {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }

  timer = setTimeout(function () {
    onScrollEnd(state)
  }, 50)
}

function onScrollEnd(state: UseScrollReturn) {
  if (!gallery.value) {
    return
  }

  const galleryWidth = gallery.value.offsetWidth

  const scrollLeft = state.x.value
  const scrollRight = state.x.value + galleryWidth

  activeItem.value
    = galleryItems.value.find((item) => {
      const itemCenter = item.index * galleryWidth - galleryWidth / 2
      return itemCenter > scrollLeft && itemCenter < scrollRight
    }) || null
}

function openFullscreen() {
  if (props.isDesktop) {
    galleryFullscreen()
  }
}
</script>

<template>
  <ul
    ref="gallery"
    v-scroll="onScroll"
    class="media-gallery-main"
  >
    <li
      v-for="item in galleryItems"
      :key="item.src"
      class="media-gallery-main__item"
      :data-item="item.index"
      @click="openFullscreen"
    >
      <UiVideo
        v-if="item.type === 'video'"
        :src="item.src"
        width="720"
        height="870"
        :autoplay="activeItem?.index === item.index"
        :controls="true"
        playsinline
        loop
        muted
        class="media-gallery-main__video"
      />

      <!--      <img -->
      <!--        v-else-if="item.type === 'image'" -->
      <!--        :src="getImageFromProvider(item, { width: 720 })" -->
      <!--        :alt="item.alt" -->
      <!--        width="720" -->
      <!--        height="870" -->
      <!--        loading="lazy" -->
      <!--        class="media-gallery-main__img" -->
      <!--      > -->
      <picture
        v-else
        class="media__picture"
      >
        <source
          :srcset="getImageFromProvider(item, { width: 1140, height: 795 })"
          media="(min-width: 1280px)"
        >
        <source
          :srcset="getImageFromProvider(item, { width: 960, height: 669 })"
          media="(min-width: 1024px)"
        >
        <source
          :srcset="getImageFromProvider(item, { width: 955, height: 724 })"
          media="(min-width: 768px)"
        >
        <source
          :srcset="getImageFromProvider(item, { width: 768, height: 582 })"
          media="(min-width: 640px)"
        >
        <source
          :srcset="getImageFromProvider(item, { width: 640, height: 485 })"
        >
        <img
          class="media-gallery-main__img"
          :src="getImageFromProvider(item, { width: 1140, height: 795 })"
          :alt="`${item.alt || ''}`"
          loading="lazy"
          fetchpriority="low"
          decoding="async"
        >
      </picture>
    </li>
  </ul>
</template>

<style>
  @import url("~layers/app/components/Ui/MediaGallery/Main.css");
</style>
